import { forwardRef } from 'react';

interface ISusyInputProps
    extends React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    dataTestId?: string;
}

const SusyInput = forwardRef(
    (props: ISusyInputProps, ref: React.Ref<HTMLInputElement>) => {
        const { dataTestId, ...componentProps } = props;
        return (
            <input
                {...componentProps}
                ref={ref}
                className={`susy-input form-control ${props.className}`}
                data-testid={dataTestId}
            />
        );
    }
);

SusyInput.displayName = 'SusyInput';

export default SusyInput;
